<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <div :class="cn('flex flex-col gap-3 px-5', props.class)">
    <slot />
  </div>
</template>
